// @core/api/endpoints/platform/update_platform_branding.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformBrandingResponse,
  UpdatePlatformBrandingRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update platform branding
 * Updates the platform's visual branding including logos, color schemes, and custom CSS. Changes are reflected immediately across the platform.
 */
export async function UpdatePlatformBranding(
  platform_id: string,
  data: UpdatePlatformBrandingRequest,
  options?: RequestOptions
): Promise<PlatformBrandingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/branding`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.put<PlatformBrandingResponse>(requestPath, data, requestOptions);
}
